<template>
  <v-form ref="form">
    <v-row justify="center" style="display: none">
      <v-dialog v-model="dialog" persistent max-width="675">
        <v-card id="layerEditingDialog">
          <v-card-title class="headline">{{ $i18n.t('settings.layersList.editSystemLayers') }}</v-card-title>
          <v-row no-gutters style="min-height: 400px" class="pl-5">
            <layer-style
              class="mt-4"
              :geometry-type="computedLayer.geometry_type"
              :layer-attributes="computedLayer.fields"
              :layer-id="computedLayer.id"
              :layer-style.sync="computedLayer.style"
              :is-style-valid.sync="isStyleValid"
            />
          </v-row>
          <v-card-actions>
            <div class="flex-grow-1" />
            <v-btn color="primary" text @click="cancelDelete">{{ $i18n.t('default.cancel') }}</v-btn>
            <v-btn
              color="primary"
              text
              @click="confirmSuccess"
              :disabled="!isStyleValid"
            >{{ $i18n.t('default.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-form>
</template>

<script>
export default {
  components: {
    LayerStyle: () => import('@/components/settings/LayerStyle')
  },
  props: {
    dialog: {
      required: true,
      type: Boolean
    },
    layer: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    isStyleValid: false
  }),
  computed: {
    computedLayer: {
      get() {
        return this.layer;
      },
      set(nV) {
        this.$emit('update:layer', nV);
      }
    }
  },
  methods: {
    confirmSuccess() {
      this.$emit('success');
    },
    cancelDelete() {
      this.$emit('cancel');
    }
  }
};
</script>